import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import { getRecover } from "api/users";
import Card from "components/card";
import DivLoader from "components/divloader/DivLoader";
import InputField from "components/fields/InputField";
import React from "react";
import { toast } from "react-hot-toast";

const Recover = ({
  setModel2FA,
  setData,
  loginData
}: {
  status?: any;
  data?: any;
  fetch2fa?: () => void;
  profileData?: any;
  fetchProfile?: () => void;
  setModel2FA?: any;
  setData?: any;
  loginData?: any;
}) => {
  const verifyData = loginData;
  const rootForm = { recover_key: "" };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [formValues, setFormValues] = React.useState<any>(rootForm);
  const [formValuesErr, setFormValuesErr] = React.useState<any>(rootForm);

  const handleClose = () => {
    setFormValues(rootForm);
    setFormValuesErr(rootForm);
    onClose();
  };

  function handleValueChange(e: any) {
    setFormValues((preVal: any) => ({ ...preVal, [e.target.id]: e.target.value }));
    setFormValuesErr((preVal: any) => ({ ...preVal, [e.target.id]: "" }));
  }

  function validateData() {
    if (formValues.recover_key.length < 6) {
      setFormValuesErr((preval: any) => ({ ...preval, recover_key: "Recover key must be required" }));
      return false;
    }
    return true;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();
    if (validateData()) {
      try {
        setIsLoading(true);
        await getRecover({ recover_key: formValues?.recover_key?.trim(), user_id: verifyData?.user_id })
          .then((data) => {
            handleClose();
            setModel2FA(formValues?.recover_key);
            setData(data);
            toast.success(data?.message ?? "Recover key verified successfully");
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message ?? "Something went wrong while fetching Recover");
          });
      } catch (err: any) {
        if (err?.response?.status === 422) toast.error("Please provide valid values");
        else toast.error(err?.response?.data?.message ?? "Unable save user data");
      } finally {
        setIsLoading(false);
      }
    }
  }

  const handelEnter = (event: any) => {
    if ((event.keyCode || event.which) === 13) handleSubmit(event);
  };

  return (
    <>
      <p onClick={onOpen} className="cursor-pointer font-medium text-brand-500 hover:text-brand-600 dark:text-white">
        Recover Authentication
      </p>

      <Modal isOpen={isOpen} onClose={() => {}} isCentered>
        <ModalOverlay className="bg-[#000] !opacity-30" />
        {/*
          KEY FIX: Removed min-w-[480px] and lg:min-w-[520px] Tailwind classes.
          Those were forcing a minimum width wider than mobile screens.
          Now using only !max-w-[95%] so Chakra's width is fully overridden by our CSS.
        */}
        <ModalContent className="!z-[1002] !m-auto !w-full !max-w-[95%] !p-0 rca-modal-content">
          <ModalBody style={{ padding: 0 }}>
            <div className="tfa-modal">
              {/* Header */}
              <div className="tfa-modal-header">
                <div className="tfa-modal-header-left">
                  <div className="tfa-header-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                    </svg>
                  </div>
                  <div>
                    <h1 className="tfa-modal-title">Recover Authentication</h1>
                  </div>
                </div>
                <button className="tfa-close-btn" onClick={handleClose} aria-label="Close">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>

              {/* Body */}
              <div className="tfa-modal-body">
                <div className="tfa-section tfa-section--last">
                  <div className="tfa-section-header">
                    <h2 className="tfa-section-title">Recover Key</h2>
                  </div>
                  <p className="tfa-verify-hint">Must provide it when you want to reset your 2FA</p>
                  <div className="si-field">
                    <div className="si-inp-wrap">
                      <span className="si-inp-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                        </svg>
                      </span>
                      <input
                        id="recover_key"
                        type="text"
                        placeholder="recover key"
                        value={formValues?.recover_key}
                        onChange={handleValueChange}
                        onKeyDown={handelEnter}
                        className={`si-inp${formValuesErr?.recover_key ? " si-inp--err" : ""}`}
                      />
                    </div>
                    {formValuesErr?.recover_key && (
                      <p className="si-err-msg">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                        </svg>
                        {formValuesErr?.recover_key}
                      </p>
                    )}
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="tfa-modal-footer">
                <div className="tfa-security-note">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                  2FA adds a critical extra layer of security
                </div>
                <div className="tfa-footer-btns">
                  <button onClick={handleClose} className="tfa-btn-cancel">Cancel</button>
                  <button onClick={handleSubmit} className="tfa-btn-verify" disabled={isLoading}>
                    {isLoading ? (
                      <span className="tfa-spinner" />
                    ) : (
                      <>
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        Verify
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* ── Override Chakra's ModalContent sizing for all screens ── */
        .rca-modal-content {
          /* Desktop default */
          max-width: 520px !important;
          width: 520px !important;
        }

        /* ── Input field ── */
        .si-field { display: flex; flex-direction: column; gap: 6px; }
        .si-inp-wrap { position: relative; display: flex; align-items: center; }
        .si-inp-icon { position: absolute; left: 14px; color: #94a3b8; display: flex; align-items: center; pointer-events: none; }
        .si-inp {
          width: 100%; padding: 13px 44px 13px 42px;
          background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 12px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 15px; color: #0f172a;
          outline: none; transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
          -webkit-appearance: none; box-sizing: border-box;
        }
        .si-inp::placeholder { color: #cbd5e1; }
        .si-inp:hover { border-color: #cbd5e1; background: #f1f5f9; }
        .si-inp:focus { border-color: #2563eb; background: #ffffff; box-shadow: 0 0 0 3px rgba(37,99,235,0.1); }
        .si-inp--err { border-color: #ef4444 !important; background: #fff7f7 !important; box-shadow: 0 0 0 3px rgba(239,68,68,0.08) !important; }
        .si-err-msg { display: flex; align-items: center; gap: 5px; font-size: 12px; color: #dc2626; font-weight: 500; margin-top: 2px; }

        /* ── Modal shell ── */
        .tfa-modal {
          font-family: 'Plus Jakarta Sans', sans-serif;
          background: #ffffff; border-radius: 20px; overflow: hidden;
          box-shadow: 0 24px 80px rgba(0,0,0,0.16), 0 4px 16px rgba(0,0,0,0.08);
          display: flex; flex-direction: column;
          width: 100%; max-height: 92vh;
        }

        /* ── Header ── */
        .tfa-modal-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 22px 28px 20px; border-bottom: 1px solid #f1f5f9;
          background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%); flex-shrink: 0;
        }
        .tfa-modal-header-left { display: flex; align-items: center; gap: 14px; min-width: 0; }
        .tfa-header-icon {
          width: 44px; height: 44px; background: linear-gradient(135deg, #eff6ff, #dbeafe);
          border: 1.5px solid #bfdbfe; border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
          color: #2563eb; flex-shrink: 0;
        }
        .tfa-modal-title {
          font-size: 17px; font-weight: 800; color: #0f172a;
          letter-spacing: -0.3px; margin-bottom: 2px;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        .tfa-close-btn {
          width: 34px; height: 34px; background: #f1f5f9; border: none; border-radius: 9px;
          cursor: pointer; display: flex; align-items: center; justify-content: center;
          color: #64748b; transition: all 0.15s; flex-shrink: 0; margin-left: 8px;
        }
        .tfa-close-btn:hover { background: #e2e8f0; color: #0f172a; }

        /* ── Body ── */
        .tfa-modal-body { overflow-y: auto; overflow-x: hidden; flex: 1; padding: 0 28px; }
        .tfa-modal-body::-webkit-scrollbar { width: 4px; }
        .tfa-modal-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* ── Sections ── */
        .tfa-section { padding: 22px 0; border-bottom: 1px solid #f1f5f9; }
        .tfa-section--last { border-bottom: none; padding-bottom: 22px; }
        .tfa-section-header { display: flex; align-items: center; gap: 10px; margin-bottom: 6px; }
        .tfa-section-title { font-size: 14px; font-weight: 700; color: #1e293b; line-height: 1.4; }
        .tfa-verify-hint { font-size: 13px; color: #64748b; margin-bottom: 18px; line-height: 1.5; }

        /* ── Footer ── */
        .tfa-modal-footer {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 12px; padding: 18px 28px 22px;
          border-top: 1px solid #f1f5f9; background: #fafbfc; flex-shrink: 0;
        }
        .tfa-security-note { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #94a3b8; font-weight: 500; }
        .tfa-footer-btns { display: flex; align-items: center; gap: 10px; margin-left: auto; }
        .tfa-btn-cancel {
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 600;
          padding: 10px 20px; border-radius: 10px; border: 1.5px solid #e2e8f0;
          background: #fff; color: #64748b; cursor: pointer; transition: all 0.15s; white-space: nowrap;
        }
        .tfa-btn-cancel:hover { background: #f1f5f9; border-color: #cbd5e1; color: #374151; }
        .tfa-btn-verify {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 22px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #1d4ed8, #2563eb); cursor: pointer;
          box-shadow: 0 4px 14px rgba(37,99,235,0.3); white-space: nowrap;
          transition: transform 0.15s, box-shadow 0.18s, opacity 0.18s;
          position: relative; overflow: hidden;
        }
        .tfa-btn-verify::after { content: ''; position: absolute; inset: 0; background: linear-gradient(135deg, rgba(255,255,255,0.1), transparent 60%); }
        .tfa-btn-verify:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(37,99,235,0.38); }
        .tfa-btn-verify:active { transform: translateY(0); }
        .tfa-btn-verify:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

        .tfa-spinner {
          display: inline-block; width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.35); border-top-color: #fff;
          border-radius: 50%; animation: tfaSpin 0.65s linear infinite;
        }
        @keyframes tfaSpin { to { transform: rotate(360deg); } }

        /* ══ RESPONSIVE ══ */

        /* Large screens (≥1280px) */
        @media (min-width: 1280px) {
          .rca-modal-content { max-width: 560px !important; width: 560px !important; }
          .tfa-modal-header { padding: 24px 32px 22px; }
          .tfa-modal-body   { padding: 0 32px; }
          .tfa-modal-footer { padding: 20px 32px 24px; }
          .tfa-modal-title  { font-size: 18px; }
        }

        /* Tablet (≤768px) */
        @media (max-width: 768px) {
          .rca-modal-content { max-width: 90vw !important; width: 90vw !important; }
          .tfa-modal { border-radius: 16px; }
          .tfa-modal-header { padding: 18px 22px 16px; }
          .tfa-header-icon  { width: 38px; height: 38px; border-radius: 10px; }
          .tfa-header-icon svg { width: 17px; height: 17px; }
          .tfa-modal-title  { font-size: 15px; }
          .tfa-modal-body   { padding: 0 22px; }
          .tfa-modal-footer { padding: 16px 22px 18px; }
          .tfa-verify-hint  { font-size: 12.5px; margin-bottom: 14px; }
        }

        /* Mobile (≤560px) — the main fix for your screenshot */
        @media (max-width: 560px) {
          /* Chakra modal content: full width with small margin */
          .rca-modal-content {
            max-width: calc(100vw - 24px) !important;
            width: calc(100vw - 24px) !important;
            margin: 12px auto !important;
          }

          .tfa-modal { border-radius: 14px; max-height: 94vh; }
          .tfa-modal-header { padding: 15px 16px 13px; }
          .tfa-header-icon  { width: 34px; height: 34px; border-radius: 9px; }
          .tfa-header-icon svg { width: 15px; height: 15px; }
          .tfa-modal-title  { font-size: 14px; }
          .tfa-close-btn    { width: 30px; height: 30px; }
          .tfa-modal-body   { padding: 0 16px; }

          /* Footer stacks: full-width buttons */
          .tfa-modal-footer {
            padding: 13px 16px 16px;
            flex-direction: column; align-items: stretch; gap: 8px;
          }
          .tfa-security-note { display: none; }
          .tfa-footer-btns { width: 100%; margin-left: 0; gap: 8px; }
          .tfa-btn-cancel {
            flex: 1; text-align: center;
            padding: 11px 12px; font-size: 13px; border-radius: 9px;
          }
          .tfa-btn-verify {
            flex: 1; justify-content: center;
            padding: 11px 12px; font-size: 13px; border-radius: 9px;
          }

          .tfa-section      { padding: 16px 0; }
          .tfa-section--last { padding-bottom: 16px; }
          .tfa-section-title { font-size: 13px; }
          .tfa-verify-hint  { font-size: 12px; margin-bottom: 12px; }
          .si-inp { font-size: 14px; padding: 12px 40px 12px 40px; border-radius: 10px; }
        }

        /* Very small (≤380px) */
        @media (max-width: 380px) {
          .rca-modal-content {
            max-width: calc(100vw - 16px) !important;
            width: calc(100vw - 16px) !important;
            margin: 8px auto !important;
          }
          .tfa-modal { border-radius: 12px; }
          .tfa-modal-header { padding: 13px 14px 11px; }
          .tfa-modal-body   { padding: 0 14px; }
          .tfa-modal-footer { padding: 11px 14px 14px; }
          .tfa-modal-title  { font-size: 13px; }
          .tfa-header-icon  { width: 30px; height: 30px; }
          .tfa-close-btn    { width: 28px; height: 28px; }
          .tfa-close-btn svg { width: 14px; height: 14px; }
          .si-inp { font-size: 13.5px; padding: 11px 36px; }
          .tfa-btn-cancel, .tfa-btn-verify { font-size: 12.5px; padding: 10px 10px; }
        }
      `}</style>
    </>
  );
};

export default Recover;